export class AmexPromo {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "AmexPromo";
    this.scene = "Attendance";
    this.data = [];
  }

  preview({ options }) {
    this.sendPreview(this.scene, 500, this.data, "IN");
  }
  animate({ options }) {
    this.onAir = true;
    this.onAir = false;
    this.data = [];
    const integerSuperShot = parseInt(options.superShot);
    const SuperShotnum = (integerSuperShot !== undefined && integerSuperShot !== null && !isNaN(integerSuperShot))
    ? integerSuperShot : "1";
    this.data.push({
      name: "Attendance",
      value: {
        text: SuperShotnum,
      },
    });
    this.sendAnimate(this.scene, this.data);
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff(this.scene, []);
  }
}
